module.exports = "/_next/static/assets/img/capic-de1a42dcee8b677c105d73083e13ffda.jpg";